export const json = {
  "title": "Pertanyaan",
  "pages": [
   {
    "name": "halaman satu",
    "elements": [
     {
      "type": "dropdown",
      "name": "jalur_masuk",
      "title": "Jalur Masuk?",
      "isRequired": true,
      "choices": [
       {
        "value": "SNMPTM",
        "text": "SNMPTM"
       },
       {
        "value": "SBMPTN",
        "text": "SBMPTN"
       },
       {
        "value": "MANDIRI",
        "text": "MANDIRI"
       },
       {
        "value": "PMPAP",
        "text": "PMPAP"
       },
       {
        "value": "PMPB",
        "text": "PMPB"
       },
       {
        "value": "LAINNYA",
        "text": "LAINNYA"
       }
      ]
     },
     {
      "type": "dropdown",
      "name": "sumber_dana_kuliah",
      "title": "Sebutkan sumber dana dalam pembiayaan kuliah?",
      "isRequired": true,
      "choices": [
       {
        "value": "Biaya Sendiri/Keluarga",
        "text": "Biaya Sendiri/Keluarga"
       },
       {
        "value": "Beasiswa ADIK",
        "text": "Beasiswa ADIK"
       },
       {
        "value": "BIDIKMISI",
        "text": "BIDIKMISI"
       },
       {
        "value": "Beasiswa PPA",
        "text": "Beasiswa PPA"
       },
       {
        "value": "PMPAP",
        "text": "PMPAP"
       },
       {
        "value": "Beasiswa AFIRMASI",
        "text": "Beasiswa AFIRMASI"
       },
       {
        "value": "Beasiswa Perusahaan/Swasta",
        "text": "Beasiswa Perusahaan/Swasta"
       }
      ]
     },
     {
      "type": "matrix",
      "name": "metode_pembelajaran",
      "title": "Menurut Anda seberapa besar penekanan pada metode pembelajaran dibawah ini dilaksanakan di program studi Anda? ",
      "isRequired": true,
      "columns": [
       {
        "value": "Sangat Besar",
        "text": "Sangat Besar"
       },
       {
        "value": "Besar",
        "text": "Besar"
       },
       {
        "value": "Cukup Besar",
        "text": "Cukup Besar"
       },
       {
        "value": "Kurang",
        "text": "Kurang"
       },
       {
        "value": "Tidak Sama Sekali",
        "text": "Tidak Sama Sekali"
       }
      ],
      "rows": [
       {
        "value": "Perkuliahan",
        "text": "Perkuliahan"
       },
       {
        "value": "Demonstrasi",
        "text": "Demonstrasi"
       },
       {
        "value": "Partisipasi dalam proyek riset",
        "text": "Partisipasi dalam proyek riset"
       },
       {
        "value": "Praktikum",
        "text": "Praktikum"
       },
       {
        "value": "Kerja Lapangan",
        "text": "Kerja Lapangan"
       },
       {
        "value": "Diskusi",
        "text": "Diskusi"
       }
      ]
     },
     {
      "type": "dropdown",
      "name": "mengetahui_cced",
      "title": "Apakah Anda mengetahui adanya Center for Career and Entrepreneuship Development University of Lampung (CCED Unila)?",
      "isRequired": true,
      "choices": [
       {
        "value": "Ya",
        "text": "Ya"
       },
       {
        "value": "Tidak",
        "text": "Tidak"
       }
      ]
     },
     {
      "type": "dropdown",
      "name": "layanan_cced",
      "title": "Apakah Anda memanfaatkan layanan yang tersedia di CCED Unila?",
      "isRequired": true,
      "choices": [
       {
        "value": "Ya",
        "text": "Ya"
       },
       {
        "value": "item2",
        "text": "Tidak"
       }
      ]
     },
     {
      "type": "dropdown",
      "name": "pendapatan_pertama",
      "title": "Bagaimana Anda memperoleh Pendapatan Pertama?",
      "isRequired": true,
      "choices": [
       {
        "value": "item1",
        "text": "Bekerja"
       },
       {
        "value": "item2",
        "text": "Berwirausaha"
       },
       {
        "value": "item3",
        "text": "Belum memperoleh pekerjaan pertama ataupun mendirikan usaha"
       }
      ]
     },
     {
      "type": "dropdown",
      "name": "question6",
      "visibleIf": "{pendapatan_pertama}='item1'",
      "title": "Kapan pertama kali Anda mencari pekerjaan?",
      "isRequired": true,
      "choices": [
       {
        "value": "item1",
        "text": "Sebelum Wisuda"
       },
       {
        "value": "item2",
        "text": "Sesudah Wisuda"
       }
      ]
     },
     {
      "type": "text",
      "name": "question6_1",
      "visibleIf": "{question6}='item1'",
      "title": "Berapa bulan sebelum wisuda?",
      "isRequired": true
     },
     {
      "type": "text",
      "name": "question6_2",
      "visibleIf": "{question6}='item2'",
      "title": "Berapa bulan sesudah wisuda?",
      "isRequired": true
     },
     {
      "type": "dropdown",
      "name": "memperoleh_pekerjaan_pertama",
      "visibleIf": "{pendapatan_pertama}='item1'",
      "title": "Kapan Anda memperoleh pekerjaan pertama?",
      "isRequired": true,
      "choices": [
       {
        "value": "item1",
        "text": "Sebelum Wisuda"
       },
       {
        "value": "item2",
        "text": "Sesudah Wisuda"
       }
      ]
     },
     {
      "type": "text",
      "name": "question7_1",
      "visibleIf": "{memperoleh_pekerjaan_pertama}='item1'",
      "title": "Berapa bulan sebelum wisuda?",
      "isRequired": true
     },
     {
      "type": "text",
      "name": "question7_2",
      "visibleIf": "{memperoleh_pekerjaan_pertama}='item2'",
      "title": "Berapa bulan sesudah wisuda?",
      "isRequired": true
     },
     {
      "type": "dropdown",
      "name": "merencanakan_berwirausaha",
      "visibleIf": "{pendapatan_pertama}='item2'",
      "title": "Kapan pertama kali Anda mulai merencanakan berwirausaha?",
      "isRequired": true,
      "choices": [
       {
        "value": "item1",
        "text": "Sebelum Wisuda"
       },
       {
        "value": "item2",
        "text": "Sesudah Wisuda"
       }
      ]
     },
     {
      "type": "text",
      "name": "question8_1",
      "visibleIf": "{merencanakan_berwirausaha}='item1'",
      "title": "Berapa bulan sebelum wisuda?",
      "isRequired": true
     },
     {
      "type": "text",
      "name": "question8_2",
      "visibleIf": "{merencanakan_berwirausaha}='item2'",
      "title": "Berapa bulan sesudah wisuda?",
      "isRequired": true
     },
     {
      "type": "dropdown",
      "name": "mendirikan_usaha",
      "visibleIf": "{pendapatan_pertama}='item2'",
      "title": "Kapan Anda mulai mendirikan usaha?",
      "isRequired": true,
      "choices": [
       {
        "value": "item1",
        "text": "Sebelum Wisuda"
       },
       {
        "value": "item2",
        "text": "Sesudah Wisuda"
       }
      ]
     },
     {
      "type": "text",
      "name": "question9_1",
      "visibleIf": "{mendirikan_usaha}='item1'",
      "title": "Berapa bulan sebelum wisuda?",
      "isRequired": true
     },
     {
      "type": "text",
      "name": "question9_2",
      "visibleIf": "{mendirikan_usaha}='item2'",
      "title": "Berapa bulan sesudah wisuda?",
      "isRequired": true
     },
     {
      "type": "dropdown",
      "name": "mulai_mencari_pekerjaan_berwirausaha",
      "visibleIf": "{pendapatan_pertama}='item3'",
      "title": "Kapan pertama kali Anda mulai mencari pekerjaan / merencanakan berwirausaha?",
      "isRequired": true,
      "choices": [
       {
        "value": "item1",
        "text": "Sebelum Wisuda"
       },
       {
        "value": "item2",
        "text": "Sesudah Wisuda"
       },
       {
        "value": "item3",
        "text": "Sampai sekarang saya belum mencari pekerjaan ataupun merencanakan berwirausaha"
       }
      ]
     },
     {
      "type": "text",
      "name": "question10_1",
      "visibleIf": "{mulai_mencari_pekerjaan_berwirausaha}='item1'",
      "title": "Berapa bulan sebelum wisuda?",
      "isRequired": true
     },
     {
      "type": "text",
      "name": "question10_2",
      "visibleIf": "{mulai_mencari_pekerjaan_berwirausaha}='item2'",
      "title": "Berapa bulan sesudah wisuda?",
      "isRequired": true
     }
    ]
   },
   {
    "name": "halaman kedua",
    "elements": [
     {
      "type": "dropdown",
      "name": "situasi_saat_ini",
      "title": "Situasi Anda saat ini?",
      "isRequired": true,
      "choices": [
       {
        "value": "item1",
        "text": "Bekerja"
       },
       {
        "value": "item2",
        "text": "Berwirausaha"
       },
       {
        "value": "item3",
        "text": "Melanjutkan Studi"
       },
       {
        "value": "item4",
        "text": "Tidak Bekerja"
       }
      ]
     },
     {
      "type": "checkbox",
      "name": "bagaimana_anda_mencari_pekerjaan",
      "visibleIf": "{situasi_saat_ini}='item1'",
      "title": "Bagaimana Anda Mencari Pekerjaan Tersebut?",
      "isRequired": true,
      "choices": [
       {
        "value": "Melalui iklan di koran/majalah, brosur",
        "text": "Melalui iklan di koran/majalah, brosur"
       },
       {
        "value": "Melamar keperusahaan tanpa mengetahui lowongan yang ada",
        "text": "Melamar keperusahaan tanpa mengetahui lowongan yang ada"
       },
       {
        "value": "Pergi ke bursa/pameran kerja",
        "text": "Pergi ke bursa/pameran kerja"
       },
       {
        "value": "Mencari lewat internet/iklan online/milis",
        "text": "Mencari lewat internet/iklan online/milis"
       },
       {
        "value": "Dihubungi oleh perusahaan",
        "text": "Dihubungi oleh perusahaan"
       },
       {
        "value": "Menghubungi Kemenakertrans",
        "text": "Menghubungi Kemenakertrans"
       },
       {
        "value": "Menghubungi agen tenaga kerja komersial/swasta",
        "text": "Menghubungi agen tenaga kerja komersial/swasta"
       },
       {
        "value": "Memeroleh informasi dari pusat/kantor pengembangan karir fakultas/universitas",
        "text": "Memeroleh informasi dari pusat/kantor pengembangan karir fakultas/universitas"
       },
       {
        "value": "Menghubungi kantor kemahasiswaan/hubungan alumni",
        "text": "Menghubungi kantor kemahasiswaan/hubungan alumni"
       },
       {
        "value": "Membangun jejaring (network) sejak masih kuliah",
        "text": "Membangun jejaring (network) sejak masih kuliah"
       },
       {
        "value": "Melalui relasi (misalnya dosen, orang tua, saudara, teman, dll",
        "text": "Melalui relasi (misalnya dosen, orang tua, saudara, teman, dll"
       },
       {
        "value": "Melalui penempatan kerja atau magang",
        "text": "Melalui penempatan kerja atau magang"
       },
       {
        "value": "Bekerja ditempat yang sama dengan tempat kerja semasa kuliah",
        "text": "Bekerja ditempat yang sama dengan tempat kerja semasa kuliah"
       }
      ]
     },
     {
      "type": "text",
      "name": "berapa_yang_sudah_dilamar_sebelum_bekerja_pertama",
      "visibleIf": "{situasi_saat_ini}='item1'",
      "title": "Berapa perusahaan, instansi, institusi yang sudah Anda lamar (termasuk lewat surat dan E-mail) sebelum Anda memperoleh pekerjaan pertama?",
      "isRequired": true
     },
     {
      "type": "text",
      "name": "berapa_perusahaan_merespon_lamaran",
      "visibleIf": "{situasi_saat_ini}='item1'",
      "title": "Berapa perusahaan, instansi, institusi yang merespon lamaran Anda?",
      "isRequired": true
     },
     {
      "type": "text",
      "name": "berapa_perusahaan_mengundang_wawancara?",
      "visibleIf": "{situasi_saat_ini}='item1'",
      "title": "Berapa perusahaan, instansi, institusi yang mengundang Anda untuk wawancara?",
      "isRequired": true
     },
     {
      "type": "dropdown",
      "name": "jenis_perusahaan_tempat_bekerja",
      "visibleIf": "{situasi_saat_ini}='item1'",
      "title": "Apa jenis perusahaan, instansi, institusi tempat Anda bekerja?",
      "isRequired": true,
      "choices": [
       {
        "value": "Perusahaan Swasta",
        "text": "Perusahaan Swasta"
       },
       {
        "value": "Organisasi Nirlaba",
        "text": "Organisasi Nirlaba"
       },
       {
        "value": "Institusi/organisasi multilateral",
        "text": "Institusi/organisasi multilateral"
       },
       {
        "value": "Lembaga Pemerintah",
        "text": "Lembaga Pemerintah"
       },
       {
        "value": "BUMN/BUMD",
        "text": "BUMN/BUMD"
       },
       {
        "value": "Lain-lain",
        "text": "Lain-lain"
       }
      ]
     },
     {
      "type": "text",
      "name": "nama_perusahaan",
      "visibleIf": "{situasi_saat_ini}='item1'",
      "title": "Nama Perusaahaan?",
      "isRequired": true
     },
     {
      "type": "text",
      "name": "provinsi_tempat_kerja",
      "visibleIf": "{situasi_saat_ini}='item1'",
      "title": "Provinsi tempat Anda bekerja?",
      "isRequired": true
     },
     {
      "type": "text",
      "name": "kota_tempat_kerja",
      "visibleIf": "{situasi_saat_ini}='item1'",
      "title": "Kota tempat Anda bekerja?",
      "isRequired": true
     },
     {
      "type": "text",
      "name": "nama_atasan",
      "visibleIf": "{situasi_saat_ini}='item1'",
      "title": "Nama Atasan Langsung?",
      "isRequired": true
     },
     {
      "type": "text",
      "name": "nomer_wa_atasan",
      "visibleIf": "{situasi_saat_ini}='item1'",
      "title": "Nomor WA Atasan Langsung?",
      "isRequired": true
     },
     {
      "type": "text",
      "name": "question25",
      "visibleIf": "{situasi_saat_ini}='item1'",
      "title": "Email Atasan Langsung?",
      "isRequired": true,
      "inputType": "email"
     },
     {
      "type": "dropdown",
      "name": "bidang_pekerjaan",
      "visibleIf": "{situasi_saat_ini}='item1'",
      "title": "Pekerjaan tempat Anda bekerja bergerak di bidang apa?",
      "isRequired": true,
      "choices": [
       {
        "value": "Kegiatan Badan Internasional dan Badan Ekstra Internasional",
        "text": "Kegiatan Badan Internasional dan Badan Ekstra Internasional"
       },
       {
        "value": "Pengadaan air, Pengelolaan Sampah dan Daur Ulang, Pembuangan dan Pembersihan Limbah dan Sampah",
        "text": "Pengadaan air, Pengelolaan Sampah dan Daur Ulang, Pembuangan dan Pembersihan Limbah dan Sampah"
       },
       {
        "value": "Pertambangan dan Penggalian",
        "text": "Pertambangan dan Penggalian"
       },
       {
        "value": "Jasa Perorangan yang Melayani Rumah Tangga",
        "text": "Jasa Perorangan yang Melayani Rumah Tangga"
       },
       {
        "value": "Jasa Profesional, Ilmiah dan Teknis",
        "text": "Jasa Profesional, Ilmiah dan Teknis"
       },
       {
        "value": "Kebudayaan Hiburan dan Rekreasi",
        "text": "Kebudayaan Hiburan dan Rekreasi"
       },
       {
        "value": "Jasa Persewaan, Ketenagakerjaan, Agen Perjalanan dan Penunjang Usaha Lainnya",
        "text": "Jasa Persewaan, Ketenagakerjaan, Agen Perjalanan dan Penunjang Usaha Lainnya"
       },
       {
        "value": "Real Estate",
        "text": "Real Estate"
       },
       {
        "value": "Transportasi dan Pergudangan",
        "text": "Transportasi dan Pergudangan"
       },
       {
        "value": "Informasi dan Komunikasi",
        "text": "Informasi dan Komunikasi"
       },
       {
        "value": "Pengadaan Listrik, Gas, Uap/Air Panas dan Udara Dingin",
        "text": "Pengadaan Listrik, Gas, Uap/Air Panas dan Udara Dingin"
       },
       {
        "value": "Industri Pengolahan",
        "text": "Industri Pengolahan"
       },
       {
        "value": "Penyediaan Akomodasi dan Penyediaan Makan dan Minum",
        "text": "Penyediaan Akomodasi dan Penyediaan Makan dan Minum"
       },
       {
        "value": "Administrasi Pemerintahan, Pertahanan, dan Jaminan Sosial Wajib ",
        "text": "Administrasi Pemerintahan, Pertahanan, dan Jaminan Sosial Wajib "
       },
       {
        "value": "Kegiatan Jasa Lainnya",
        "text": "Kegiatan Jasa Lainnya"
       },
       {
        "value": "Pertanian, Kehutanan, Perikanan",
        "text": "Pertanian, Kehutanan, Perikanan"
       },
       {
        "value": "Jasa Kesehatan dan Kegiatan Sosial",
        "text": "Jasa Kesehatan dan Kegiatan Sosial"
       },
       {
        "value": "Konstruksi",
        "text": "Konstruksi"
       },
       {
        "value": "Perdagangan Besar dan Eceran, Reparasi dan Perawatan Mobil dan Sepeeda Motor",
        "text": "Perdagangan Besar dan Eceran, Reparasi dan Perawatan Mobil dan Sepeeda Motor"
       },
       {
        "value": "Jasa Keuangan dan Asuransi",
        "text": "Jasa Keuangan dan Asuransi"
       },
       {
        "value": "Jasa Pendidikan",
        "text": "Jasa Pendidikan"
       }
      ]
     },
     {
      "type": "text",
      "name": "pendapatan_setiap_bulan",
      "visibleIf": "{situasi_saat_ini}='item1'",
      "title": "Pendapatan Anda setiap bulan dari pekerjaan utama?",
      "isRequired": true
     },
     {
      "type": "text",
      "name": "pendapatan_setiap_bulan_lembur_tips",
      "visibleIf": "{situasi_saat_ini}='item1'",
      "title": "Pendapatan Anda setiap bulan dari lembur dan tips?"
     },
     {
      "type": "text",
      "name": "pendapatan_lain_perbulan",
      "visibleIf": "{situasi_saat_ini}='item1'",
      "title": "Pendapatan Anda setiap bulan dari pekerjaan lainnya?"
     },
     {
      "type": "dropdown",
      "name": "hubungan_bidang_studi_dengan_pekerjaan",
      "visibleIf": "{situasi_saat_ini}='item1'",
      "title": "Seberapa erat hubungan antar bidang studi dengan pekerjaan Anda?",
      "isRequired": true,
      "choices": [
       {
        "value": "Sangat Erat",
        "text": "Sangat Erat"
       },
       {
        "value": "Erat",
        "text": "Erat"
       },
       {
        "value": "Cukup Erat",
        "text": "Cukup Erat"
       },
       {
        "value": "Kurang Erat",
        "text": "Kurang Erat"
       },
       {
        "value": "Tidak Erat Sama Sekali",
        "text": "Tidak Erat Sama Sekali"
       }
      ]
     },
     {
      "type": "dropdown",
      "name": "question31",
      "visibleIf": "{situasi_saat_ini}='item1'",
      "title": "Tingkat pendidikan apa yang paling tepat/sesuai untuk pekerjaan Anda saat ini?",
      "isRequired": true,
      "choices": [
       {
        "value": "Setingkat Lebih Tinggi",
        "text": "Setingkat Lebih Tinggi"
       },
       {
        "value": "Tingkat yang Sama",
        "text": "Tingkat yang Sama"
       },
       {
        "value": "Setingkat Lebih Rendah",
        "text": "Setingkat Lebih Rendah"
       },
       {
        "value": "Tidak Perlu Pendidikan Tinggi",
        "text": "Tidak Perlu Pendidikan Tinggi"
       }
      ]
     },
     {
      "type": "dropdown",
      "name": "mengapa_mengambil_pekerjaan_tidak_sesuai",
      "visibleIf": "{situasi_saat_ini}='item1'",
      "title": "Jika Menurut Anda pekerjaan Anda saat ini tidak sesuai dengan pendidikan Anda, mengapa Anda mengambilnya?",
      "isRequired": true,
      "choices": [
       {
        "value": "Saya belum mendapatkan pekerjaan yang lebih sesuai ",
        "text": "Saya belum mendapatkan pekerjaan yang lebih sesuai "
       },
       {
        "value": "Di pekerjaan ini saya memperoleh prospek karir yang baik",
        "text": "Di pekerjaan ini saya memperoleh prospek karir yang baik"
       },
       {
        "value": "Saya lebih suka bekerja di area pekerjaan yang tidak ada hubungannya dengan pendidikan saya",
        "text": "Saya lebih suka bekerja di area pekerjaan yang tidak ada hubungannya dengan pendidikan saya"
       },
       {
        "value": "Saya dipromosikan ke posisi yang kurang berhubungan dengan pendidikan saya dibanding posisi sebelumnya",
        "text": "Saya dipromosikan ke posisi yang kurang berhubungan dengan pendidikan saya dibanding posisi sebelumnya"
       },
       {
        "value": "Saya dapat memperoleh pendapatan yang lebih tinggi di pekerjaan ini",
        "text": "Saya dapat memperoleh pendapatan yang lebih tinggi di pekerjaan ini"
       },
       {
        "value": "Pekerjaan saya saat ini lebih aman/terjamin/secure",
        "text": "Pekerjaan saya saat ini lebih aman/terjamin/secure"
       },
       {
        "value": "Pekerjaan saya saat ini lebih menarik",
        "text": "Pekerjaan saya saat ini lebih menarik"
       },
       {
        "value": "Pekerjaan saya saat ini lebih memungkinkan saya mengambil pekerjaan tambahan/jadwal yang fleksibel, dll",
        "text": "Pekerjaan saya saat ini lebih memungkinkan saya mengambil pekerjaan tambahan/jadwal yang fleksibel, dll"
       },
       {
        "value": "Pekerjaan saya saat ini lokasinya lebih dekat dari rumah saya",
        "text": "Pekerjaan saya saat ini lokasinya lebih dekat dari rumah saya"
       },
       {
        "value": "Pekerjaan saya saat ini dapat lebih menjamin kebutuhan keluarga saya",
        "text": "Pekerjaan saya saat ini dapat lebih menjamin kebutuhan keluarga saya"
       },
       {
        "value": "Pada awal meniti karier ini, saya harus menerima pekerjaan yang tidak berhubungan dengan pendidikan saya.",
        "text": "Pada awal meniti karier ini, saya harus menerima pekerjaan yang tidak berhubungan dengan pendidikan saya."
       },
       {
        "value": "Pertanyaan tidak sesuai",
        "text": "Pertanyaan tidak sesuai"
       },
       {
        "value": "Lainnya",
        "text": "Lainnya"
       }
      ]
     },
     {
      "type": "dropdown",
      "name": "sebagai_apakah",
      "visibleIf": "{situasi_saat_ini}='item2'",
      "title": "Sebagai apakah Anda?",
      "isRequired": true,
      "choices": [
       {
        "value": "item1",
        "text": "Pendiri Usaha"
       },
       {
        "value": "item2",
        "text": "Pekerja Lepas (freelancer)"
       }
      ]
     },
     {
      "type": "text",
      "name": "nama_usaha",
      "visibleIf": "{sebagai_apakah}='item1'",
      "title": "Nama Usaha?",
      "isRequired": true
     },
     {
      "type": "text",
      "name": "asal_modal_usaha",
      "visibleIf": "{sebagai_apakah}='item1'",
      "title": "Asal modal membangun Usaha?",
      "isRequired": true
     },
     {
      "type": "dropdown",
      "name": "usaha_dibidang",
      "visibleIf": "{sebagai_apakah}='item1'",
      "title": "Usaha Anda bergerak di bidang apa?",
      "isRequired": true,
      "choices": [
       {
        "value": "Kegiatan Badan Internasional dan Badan Ekstra Internasional",
        "text": "Kegiatan Badan Internasional dan Badan Ekstra Internasional"
       },
       {
        "value": "Pengadaan air, Pengelolaan Sampah dan Daur Ulang, Pembuangan dan Pembersihan Limbah dan Sampah",
        "text": "Pengadaan air, Pengelolaan Sampah dan Daur Ulang, Pembuangan dan Pembersihan Limbah dan Sampah"
       },
       {
        "value": "Pertambangan dan Penggalian",
        "text": "Pertambangan dan Penggalian"
       },
       {
        "value": "Jasa Perorangan yang Melayani Rumah Tangga",
        "text": "Jasa Perorangan yang Melayani Rumah Tangga"
       },
       {
        "value": "Jasa Profesional, Ilmiah dan Teknis",
        "text": "Jasa Profesional, Ilmiah dan Teknis"
       },
       {
        "value": "Kebudayaan Hiburan dan Rekreasi",
        "text": "Kebudayaan Hiburan dan Rekreasi"
       },
       {
        "value": "Jasa Persewaan, Ketenagakerjaan, Agen Perjalanan dan Penunjang Usaha Lainnya",
        "text": "Jasa Persewaan, Ketenagakerjaan, Agen Perjalanan dan Penunjang Usaha Lainnya"
       },
       {
        "value": "Real Estate",
        "text": "Real Estate"
       },
       {
        "value": "Transportasi dan Pergudangan",
        "text": "Transportasi dan Pergudangan"
       },
       {
        "value": "Informasi dan Komunikasi",
        "text": "Informasi dan Komunikasi"
       },
       {
        "value": "Pengadaan Listrik, Gas, Uap/Air Panas dan Udara Dingin",
        "text": "Pengadaan Listrik, Gas, Uap/Air Panas dan Udara Dingin"
       },
       {
        "value": "Industri Pengolahan",
        "text": "Industri Pengolahan"
       },
       {
        "value": "Penyediaan Akomodasi dan Penyediaan Makan dan Minum",
        "text": "Penyediaan Akomodasi dan Penyediaan Makan dan Minum"
       },
       {
        "value": "Administrasi Pemerintahan, Pertahanan, dan Jaminan Sosial Wajib ",
        "text": "Administrasi Pemerintahan, Pertahanan, dan Jaminan Sosial Wajib "
       },
       {
        "value": "Kegiatan Jasa Lainnya",
        "text": "Kegiatan Jasa Lainnya"
       },
       {
        "value": "Pertanian, Kehutanan, Perikanan",
        "text": "Pertanian, Kehutanan, Perikanan"
       },
       {
        "value": "Jasa Kesehatan dan Kegiatan Sosial",
        "text": "Jasa Kesehatan dan Kegiatan Sosial"
       },
       {
        "value": "Konstruksi",
        "text": "Konstruksi"
       },
       {
        "value": "Perdagangan Besar dan Eceran, Reparasi dan Perawatan Mobil dan Sepeda Motor",
        "text": "Perdagangan Besar dan Eceran, Reparasi dan Perawatan Mobil dan Sepeda Motor"
       },
       {
        "value": "Jasa Keuangan dan Asuransi",
        "text": "Jasa Keuangan dan Asuransi"
       },
       {
        "value": "Jasa Pendidikan",
        "text": "Jasa Pendidikan"
       }
      ]
     },
     {
      "type": "dropdown",
      "name": "alasan_berwirausaha",
      "visibleIf": "{sebagai_apakah}='item1'",
      "title": "Alasan berwirausaha?",
      "isRequired": true,
      "choices": [
       {
        "value": "Cita - cita",
        "text": "Cita - cita"
       },
       {
        "value": "Melanjutkan Usaha Keluarga",
        "text": "Melanjutkan Usaha Keluarga"
       },
       {
        "value": "Penghasilan lebih besar",
        "text": "Penghasilan lebih besar"
       },
       {
        "value": "Passion/keinginan pribadi",
        "text": "Passion/keinginan pribadi"
       },
       {
        "value": "Buka lapangan pekerjaan baru ",
        "text": "Buka lapangan pekerjaan baru "
       },
       {
        "value": "Waktu yang fleksibel",
        "text": "Waktu yang fleksibel"
       },
       {
        "value": "Bebas/tidak bergantung",
        "text": "Bebas/tidak bergantung"
       },
       {
        "value": "Malas melamar kerja",
        "text": "Malas melamar kerja"
       },
       {
        "value": "Tantangan",
        "text": "Tantangan"
       },
       {
        "value": "Peluang pasar",
        "text": "Peluang pasar"
       }
      ]
     },
     {
      "type": "text",
      "name": "nama_perusahaan_freelancer",
      "visibleIf": "{sebagai_apakah}='item2'",
      "title": "Nama Perusahaan?",
      "isRequired": true
     },
     {
      "type": "text",
      "name": "nama_atasan_freelancer",
      "visibleIf": "{sebagai_apakah}='item2'",
      "title": "Nama Atasan Langsung?",
      "isRequired": true
     },
     {
      "type": "text",
      "name": "nomer_atasan_freelancer",
      "visibleIf": "{sebagai_apakah}='item2'",
      "title": "Nomor WA Atasan Langsung? ",
      "isRequired": true
     },
     {
      "type": "text",
      "name": "email_atasan_freelancer",
      "visibleIf": "{sebagai_apakah}='item2'",
      "title": "Email Atasan Langsung?",
      "isRequired": true,
      "inputType": "email"
     },
     {
      "type": "text",
      "name": "pendapatan_berwirausaha",
      "visibleIf": "{situasi_saat_ini}='item2'",
      "title": "Pendapatan Anda setiap bulan dari pekerjaan utama? ",
      "description": "(Jika Anda pendiri hanya isi kolom pendapatan utama saja)",
      "isRequired": true
     },
     {
      "type": "text",
      "name": "question43",
      "visibleIf": "{situasi_saat_ini}='item2'",
      "title": "Pendapatan Anda setiap bulan dari lembur dan tips?"
     },
     {
      "type": "text",
      "name": "question44",
      "visibleIf": "{situasi_saat_ini}='item2'",
      "title": "Pendapatan Anda setiap bulan dari pekerjaan lainnya?"
     },
     {
      "type": "text",
      "name": "provinsi_berwirausaha",
      "visibleIf": "{situasi_saat_ini}='item2'",
      "title": "Provinsi Tempat Anda Berwirausaha?",
      "isRequired": true
     },
     {
      "type": "text",
      "name": "question45",
      "visibleIf": "{situasi_saat_ini}='item2'",
      "title": "Kota Tempat Anda Berwirausaha?"
     },
     {
      "type": "dropdown",
      "name": "hubungan_bidang_studi_dengan_berwirausaha",
      "visibleIf": "{situasi_saat_ini}='item2'",
      "title": "Seberapa erat hubungan antar bidang studi dengan pekerjaan Anda?",
      "isRequired": true,
      "choices": [
       {
        "value": "Sangat Erat",
        "text": "Sangat Erat"
       },
       {
        "value": "Erat",
        "text": "Erat"
       },
       {
        "value": "Cukup Erat",
        "text": "Cukup Erat"
       },
       {
        "value": "Kurang Erat",
        "text": "Kurang Erat"
       },
       {
        "value": "Tidak Erat Sama Sekali",
        "text": "Tidak Erat Sama Sekali"
       }
      ]
     },
     {
      "type": "dropdown",
      "name": "pendidikan_sesuai_berwirausaha",
      "visibleIf": "{situasi_saat_ini}='item2'",
      "title": "Tingkat pendidikan apa yang paling tepat/sesuai untuk pekerjaan/usaha Anda saat ini?",
      "isRequired": true,
      "choices": [
       {
        "value": "Setingkat Lebih Tinggi",
        "text": "Setingkat Lebih Tinggi"
       },
       {
        "value": "Tingkat yang Sama",
        "text": "Tingkat yang Sama"
       },
       {
        "value": "Setingkat Lebih Rendah",
        "text": "Setingkat Lebih Rendah"
       },
       {
        "value": "Tidak Perlu Pendidikan Tinggi",
        "text": "Tidak Perlu Pendidikan Tinggi"
       }
      ]
     },
     {
      "type": "dropdown",
      "name": "alasan_tidak_sesuai_berwirausahaa",
      "visibleIf": "{situasi_saat_ini}='item2'",
      "title": "Jika menurut Anda pekerjaan/usaha Anda saat ini tidak sesuai dengan pendidikan Anda, mengapa Anda mengambilnya?",
      "isRequired": true,
      "choices": [
       {
        "value": "Saya belum mendapatkan pekerjaan yang lebih sesuai ",
        "text": "Saya belum mendapatkan pekerjaan yang lebih sesuai "
       },
       {
        "value": "Di pekerjaan ini saya memperoleh prospek karir yang baik",
        "text": "Di pekerjaan ini saya memperoleh prospek karir yang baik"
       },
       {
        "value": "Saya lebih suka bekerja di area pekerjaan yang tidak ada hubungannya dengan pendidikan saya",
        "text": "Saya lebih suka bekerja di area pekerjaan yang tidak ada hubungannya dengan pendidikan saya"
       },
       {
        "value": "Saya dipromosikan ke posisi yang kurang berhubungan dengan pendidikan saya dibanding posisi sebelumnya",
        "text": "Saya dipromosikan ke posisi yang kurang berhubungan dengan pendidikan saya dibanding posisi sebelumnya"
       },
       {
        "value": "Saya dapat memperoleh pendapatan yang lebih tinggi di pekerjaan ini",
        "text": "Saya dapat memperoleh pendapatan yang lebih tinggi di pekerjaan ini"
       },
       {
        "value": "Pekerjaan saya saat ini lebih aman/terjamin/secure",
        "text": "Pekerjaan saya saat ini lebih aman/terjamin/secure"
       },
       {
        "value": "Pekerjaan saya saat ini lebih menarik ",
        "text": "Pekerjaan saya saat ini lebih menarik "
       },
       {
        "value": "Pekerjaan saya saat ini lebih memungkinkan saya mengambil pekerjaan tambahan/jadwal yang fleksibel, dll",
        "text": "Pekerjaan saya saat ini lebih memungkinkan saya mengambil pekerjaan tambahan/jadwal yang fleksibel, dll"
       },
       {
        "value": "Pekerjaan saya saat ini lokasinya lebih dekat dari rumah saya",
        "text": "Pekerjaan saya saat ini lokasinya lebih dekat dari rumah saya"
       },
       {
        "value": "Pekerjaan saya saat ini dapat lebih menjamin kebutuhan keluarga saya",
        "text": "Pekerjaan saya saat ini dapat lebih menjamin kebutuhan keluarga saya"
       },
       {
        "value": "Pada awal meniti karier ini, saya harus menerima pekerjaan yang tidak berhubungan dengan pendidikan saya.",
        "text": "Pada awal meniti karier ini, saya harus menerima pekerjaan yang tidak berhubungan dengan pendidikan saya."
       },
       {
        "value": "Pertanyaan tidak sesuai",
        "text": "Pertanyaan tidak sesuai"
       },
       {
        "value": "Lainnya",
        "text": "Lainnya"
       }
      ]
     },
     {
      "type": "text",
      "name": "nama_perguruan_tinggi",
      "visibleIf": "{situasi_saat_ini}='item3'",
      "title": "Nama Perguruan Tinggi tempat Anda melanjutkan studi",
      "isRequired": true
     },
     {
      "type": "text",
      "name": "program_studi",
      "visibleIf": "{situasi_saat_ini}='item3'",
      "title": "Jurusan / Program Studi Anda?",
      "isRequired": true
     },
     {
      "type": "text",
      "name": "provinsi_melanjutkan_studi",
      "visibleIf": "{situasi_saat_ini}='item3'",
      "title": "Provinsi Tempat Anda Melanjutkan Studi",
      "isRequired": true
     },
     {
      "type": "text",
      "name": "kota_melanjutkan_studi",
      "visibleIf": "{situasi_saat_ini}='item3'",
      "title": "Kota Tempat Anda Melanjutkan Studi",
      "isRequired": true
     },
     {
      "type": "text",
      "name": "waktu_setelah_wisuda_untuk_lanjut_studi",
      "visibleIf": "{situasi_saat_ini}='item3'",
      "title": "Berapa bulan waktu yang dibutuhkan Anda setelah wisuda untuk melanjutkan studi?",
      "isRequired": true
     },
     {
      "type": "dropdown",
      "name": "alasan_melanjutkan_studi",
      "visibleIf": "{situasi_saat_ini}='item3'",
      "title": "Apa alasan Anda untuk melanjutkan studi?",
      "isRequired": true,
      "choices": [
       {
        "value": "Tuntutan Profesi",
        "text": "Tuntutan Profesi"
       },
       {
        "value": "Kesempatan Beasiswa",
        "text": "Kesempatan Beasiswa"
       },
       {
        "value": "Prestasi",
        "text": "Prestasi"
       },
       {
        "value": "Belum ada keinginan bekerja",
        "text": "Belum ada keinginan bekerja"
       }
      ]
     },
     {
      "type": "dropdown",
      "name": "sumber_biaya_studi",
      "visibleIf": "{situasi_saat_ini}='item3'",
      "title": "Dari manakah sumber biaya studi Anda?",
      "isRequired": true,
      "choices": [
       {
        "value": "Beasiswa",
        "text": "Beasiswa"
       },
       {
        "value": "Tempat Kerja",
        "text": "Tempat Kerja"
       },
       {
        "value": "Orang Tua",
        "text": "Orang Tua"
       },
       {
        "value": "Biaya Sendiri",
        "text": "Biaya Sendiri"
       }
      ]
     },
     {
      "type": "dropdown",
      "name": "alasan_tidak_bekerja",
      "visibleIf": "{situasi_saat_ini}='item4'",
      "title": "Apa alasan Anda tidak bekerja?",
      "isRequired": true,
      "choices": [
       {
        "value": "Menikah",
        "text": "Menikah"
       },
       {
        "value": "Alasan Keluarga",
        "text": "Alasan Keluarga"
       },
       {
        "value": "Alasan kesehatan",
        "text": "Alasan kesehatan"
       },
       {
        "value": "Belum mendapatkan panggilan kerja",
        "text": "Belum mendapatkan panggilan kerja"
       },
       {
        "value": "Mengundurkan diri dari pekerjaan sebelumnya ",
        "text": "Mengundurkan diri dari pekerjaan sebelumnya "
       },
       {
        "value": "Habis masa kontrak pekerjaan sebelumnya",
        "text": "Habis masa kontrak pekerjaan sebelumnya"
       },
       {
        "value": "Belum mendapatkan panggilan kerja",
        "text": "Belum mendapatkan panggilan kerja"
       }
      ]
     },
     {
      "type": "dropdown",
      "name": "mencari_pekerjaan_empat_minggu_terahkir",
      "visibleIf": "{situasi_saat_ini}='item4'",
      "title": "Apakah Anda aktif mencari pekerjaan dalam 4 minggu terakhir?",
      "isRequired": true,
      "choices": [
       {
        "value": "Tidak",
        "text": "Tidak"
       },
       {
        "value": "Tidak, tapi saya sedang menunggu hasil lamaran kerja ",
        "text": "Tidak, tapi saya sedang menunggu hasil lamaran kerja "
       },
       {
        "value": "Ya, saya akan mulai bekerja dalam 2 minggu ke depan",
        "text": "Ya, saya akan mulai bekerja dalam 2 minggu ke depan"
       },
       {
        "value": "Ya, tapi saya belum pasti akan bekerja dalam 2 minggu ke depan.",
        "text": "Ya, tapi saya belum pasti akan bekerja dalam 2 minggu ke depan."
       }
      ]
     }
    ]
   },
   {
    "name": "halaman 3",
    "elements": [
     {
      "type": "matrix",
      "name": "tingkat_kompetensi_yang_dikuasai?",
      "title": "Pada saat ini, pada tingkat mana kompetensi di bawah ini yang Anda kuasai?",
      "isRequired": true,
      "columns": [
       "1",
       "2",
       "3",
       "4",
       "5"
      ],
      "rows": [
       {
        "value": "Pengetahuan di dalam bidang atau disiplin ilmu Anda",
        "text": "Pengetahuan di dalam bidang atau disiplin ilmu Anda"
       },
       {
        "value": "Pengetahuan di luar bidang atau disiplin ilmu Anda",
        "text": "Pengetahuan di luar bidang atau disiplin ilmu Anda"
       },
       {
        "value": "Pengetahuan umum",
        "text": "Pengetahuan umum"
       },
       {
        "value": "Bahasa Asing",
        "text": "Bahasa Asing"
       },
       {
        "value": "Keterampilan internet",
        "text": "Keterampilan internet"
       },
       {
        "value": "Keterampilan komputer",
        "text": "Keterampilan komputer"
       },
       {
        "value": "Berpikir kritis",
        "text": "Berpikir kritis"
       },
       {
        "value": "Keterampilan riset",
        "text": "Keterampilan riset"
       },
       {
        "value": "Kemampuan belajar",
        "text": "Kemampuan belajar"
       },
       {
        "value": "Kemampuan berkomunikasi",
        "text": "Kemampuan berkomunikasi"
       },
       {
        "value": "Bekerja di bawah tekanan",
        "text": "Bekerja di bawah tekanan"
       },
       {
        "value": "Manajemen waktu",
        "text": "Manajemen waktu"
       },
       {
        "value": "Bekerja secara mandiri",
        "text": "Bekerja secara mandiri"
       },
       {
        "value": "Bekerja dalam tim / bekerjasama dengan orang lain",
        "text": "Bekerja dalam tim / bekerjasama dengan orang lain"
       },
       {
        "value": "Kemampuan dalam memecahkan masalah",
        "text": "Kemampuan dalam memecahkan masalah"
       },
       {
        "value": "Negosiasi",
        "text": "Negosiasi"
       },
       {
        "value": "Kemampuan analisis",
        "text": "Kemampuan analisis"
       },
       {
        "value": "Toleransi",
        "text": "Toleransi"
       },
       {
        "value": "Kemampuan adaptasi",
        "text": "Kemampuan adaptasi"
       },
       {
        "value": "Loyalitas",
        "text": "Loyalitas"
       },
       {
        "value": "Integritas",
        "text": "Integritas"
       },
       {
        "value": "Bekerja dengan orang yang berbeda budaya maupun latar belakang",
        "text": "Bekerja dengan orang yang berbeda budaya maupun latar belakang"
       },
       {
        "value": "Kepemimpinan",
        "text": "Kepemimpinan"
       },
       {
        "value": "Kemampuan dalam memegang tanggung jawab",
        "text": "Kemampuan dalam memegang tanggung jawab"
       },
       {
        "value": "Inisiatif",
        "text": "Inisiatif"
       },
       {
        "value": "Manajemen proyek atau program",
        "text": "Manajemen proyek atau program"
       },
       {
        "value": "Kemampuan untuk memresentasikan ide atau produk atau laporan",
        "text": "Kemampuan untuk memresentasikan ide atau produk atau laporan"
       },
       {
        "value": "Kemampuan dalam menulis laporan, memo dan dokumen",
        "text": "Kemampuan dalam menulis laporan, memo dan dokumen"
       },
       {
        "value": "Kemampuan untuk terus belajar sepanjang hayat",
        "text": "Kemampuan untuk terus belajar sepanjang hayat"
       }
      ]
     },
     {
      "type": "matrix",
      "name": "question61",
      "title": "Pada saat ini, ini, pada tingkat mana kompetensi di bawah ini diperlukan dalam pekerjaan?",
      "isRequired": true,
      "columns": [
       "1",
       "2",
       "3",
       "4",
       "5"
      ],
      "rows": [
       {
        "value": "Pengetahuan di dalam bidang atau disiplin ilmu Anda",
        "text": "Pengetahuan di dalam bidang atau disiplin ilmu Anda"
       },
       {
        "value": "Pengetahuan di luar bidang atau disiplin ilmu Anda",
        "text": "Pengetahuan di luar bidang atau disiplin ilmu Anda"
       },
       {
        "value": "Pengetahuan umum",
        "text": "Pengetahuan umum"
       },
       {
        "value": "Bahasa Asing",
        "text": "Bahasa Asing"
       },
       {
        "value": "Keterampilan internet",
        "text": "Keterampilan internet"
       },
       {
        "value": "Keterampilan komputer",
        "text": "Keterampilan komputer"
       },
       {
        "value": "Berpikir kritis",
        "text": "Berpikir kritis"
       },
       {
        "value": "Keterampilan riset",
        "text": "Keterampilan riset"
       },
       {
        "value": "Kemampuan belajar",
        "text": "Kemampuan belajar"
       },
       {
        "value": "Kemampuan berkomunikasi",
        "text": "Kemampuan berkomunikasi"
       },
       {
        "value": "Bekerja di bawah tekanan",
        "text": "Bekerja di bawah tekanan"
       },
       {
        "value": "Manajemen waktu",
        "text": "Manajemen waktu"
       },
       {
        "value": "Bekerja secara mandiri",
        "text": "Bekerja secara mandiri"
       },
       {
        "value": "Bekerja dalam tim / bekerjasama dengan orang lain",
        "text": "Bekerja dalam tim / bekerjasama dengan orang lain"
       },
       {
        "value": "Kemampuan dalam memecahkan masalah",
        "text": "Kemampuan dalam memecahkan masalah"
       },
       {
        "value": "Negosiasi",
        "text": "Negosiasi"
       },
       {
        "value": "Kemampuan analisis",
        "text": "Kemampuan analisis"
       },
       {
        "value": "Toleransi",
        "text": "Toleransi"
       },
       {
        "value": "Kemampuan adaptasi",
        "text": "Kemampuan adaptasi"
       },
       {
        "value": "Loyalitas",
        "text": "Loyalitas"
       },
       {
        "value": "Integritas",
        "text": "Integritas"
       },
       {
        "value": "Bekerja dengan orang yang berbeda budaya maupun latar belakang",
        "text": "Bekerja dengan orang yang berbeda budaya maupun latar belakang"
       },
       {
        "value": "Kepemimpinan",
        "text": "Kepemimpinan"
       },
       {
        "value": "Kemampuan dalam memegang tanggung jawab",
        "text": "Kemampuan dalam memegang tanggung jawab"
       },
       {
        "value": "Inisiatif",
        "text": "Inisiatif"
       },
       {
        "value": "Manajemen proyek atau program",
        "text": "Manajemen proyek atau program"
       },
       {
        "value": "Kemampuan untuk memresentasikan ide atau produk atau laporan",
        "text": "Kemampuan untuk memresentasikan ide atau produk atau laporan"
       },
       {
        "value": "Kemampuan dalam menulis laporan, memo dan dokumen",
        "text": "Kemampuan dalam menulis laporan, memo dan dokumen"
       },
       {
        "value": "Kemampuan untuk terus belajar sepanjang hayat",
        "text": "Kemampuan untuk terus belajar sepanjang hayat"
       }
      ]
     }
    ]
   }
  ]
 }

// survey results data object
const firstResult = {
    "jalur_masuk": "PMPAP",
    "sumber_dana_kuliah": "PMPAP",
    "metode_pembelajaran": {
      "Perkuliahan": "Sangat Besar",
      "Demonstrasi": "Besar",
      "Partisipasi dalam proyek riset": "Sangat Besar",
      "Praktikum": "Sangat Besar",
      "Kerja Lapangan": "Besar",
      "Diskusi": "Cukup Besar"
    },
    "mengetahui_cced": "Ya",
    "layanan_cced": "Ya",
    "pendapatan_pertama": "item1",
    "question6": "item1",
    "question6_1": "6 bulan",
    "memperoleh_pekerjaan_pertama": "item1",
    "question7_1": "6 bulan",
    "situasi_saat_ini": "item1",
    "bagaimana_anda_mencari_pekerjaan": ["Memeroleh informasi dari pusat\/kantor pengembangan karir fakultas\/universitas"],
    "berapa_yang_sudah_dilamar_sebelum_bekerja_pertama": "0",
    "berapa_perusahaan_merespon_lamaran": "0",
    "berapa_perusahaan_mengundang_wawancara?": "0",
    "jenis_perusahaan_tempat_bekerja": "Institusi\/organisasi multilateral",
    "nama_perusahaan": "universitas lampung",
    "provinsi_tempat_kerja": "lampung",
    "kota_tempat_kerja": "bandar lampung",
    "nama_atasan": "pak budi",
    "nomer_wa_atasan": "089514213213",
    "question25": "pakbudi@gmail.com",
    "bidang_pekerjaan": "Informasi dan Komunikasi",
    "pendapatan_setiap_bulan": "3000000",
    "hubungan_bidang_studi_dengan_pekerjaan": "Sangat Erat",
    "question31": "Tingkat yang Sama",
    "mengapa_mengambil_pekerjaan_tidak_sesuai": "Di pekerjaan ini saya memperoleh prospek karir yang baik",
    "tingkat_kompetensi_yang_dikuasai?": {
      "Pengetahuan di dalam bidang atau disiplin ilmu Anda": "1",
      "Pengetahuan di luar bidang atau disiplin ilmu Anda": "1",
      "Pengetahuan umum": "3",
      "Bahasa Asing": "1",
      "Keterampilan internet": "1",
      "Keterampilan komputer": "1",
      "Berpikir kritis": "3",
      "Keterampilan riset": "1",
      "Kemampuan belajar": "1",
      "Kemampuan berkomunikasi": "3",
      "Bekerja di bawah tekanan": "1",
      "Manajemen waktu": "2",
      "Bekerja secara mandiri": "1",
      "Bekerja dalam tim \/ bekerjasama dengan orang lain": "1",
      "Kemampuan dalam memecahkan masalah": "3",
      "Negosiasi": "1",
      "Kemampuan analisis": "1",
      "Toleransi": "3",
      "Kemampuan adaptasi": "1",
      "Loyalitas": "1",
      "Integritas": "1",
      "Bekerja dengan orang yang berbeda budaya maupun latar belakang": "3",
      "Kepemimpinan": "1",
      "Kemampuan dalam memegang tanggung jawab": "1",
      "Inisiatif": "1",
      "Manajemen proyek atau program": "1",
      "Kemampuan untuk memresentasikan ide atau produk atau laporan": "1",
      "Kemampuan dalam menulis laporan, memo dan dokumen": "1",
      "Kemampuan untuk terus belajar sepanjang hayat": "1"
    },
    "question61": {
      "Pengetahuan di dalam bidang atau disiplin ilmu Anda": "1",
      "Pengetahuan di luar bidang atau disiplin ilmu Anda": "1",
      "Pengetahuan umum": "3",
      "Bahasa Asing": "1",
      "Keterampilan internet": "1",
      "Keterampilan komputer": "1",
      "Berpikir kritis": "1",
      "Keterampilan riset": "1",
      "Kemampuan belajar": "1",
      "Kemampuan berkomunikasi": "1",
      "Bekerja di bawah tekanan": "1",
      "Manajemen waktu": "1",
      "Bekerja secara mandiri": "1",
      "Bekerja dalam tim \/ bekerjasama dengan orang lain": "1",
      "Kemampuan dalam memecahkan masalah": "3",
      "Negosiasi": "1",
      "Kemampuan analisis": "1",
      "Toleransi": "1",
      "Kemampuan adaptasi": "1",
      "Loyalitas": "1",
      "Integritas": "1",
      "Bekerja dengan orang yang berbeda budaya maupun latar belakang": "1",
      "Kepemimpinan": "1",
      "Kemampuan dalam memegang tanggung jawab": "3",
      "Inisiatif": "1",
      "Manajemen proyek atau program": "1",
      "Kemampuan untuk memresentasikan ide atau produk atau laporan": "1",
      "Kemampuan dalam menulis laporan, memo dan dokumen": "2",
      "Kemampuan untuk terus belajar sepanjang hayat": "3"
    }
  }

  const secondResult = {
    "jalur_masuk": "SNMPTM",
    "sumber_dana_kuliah": "BIDIKMISI",
    "metode_pembelajaran": {
      "Perkuliahan": "Sangat Besar",
      "Demonstrasi": "Besar",
      "Partisipasi dalam proyek riset": "Sangat Besar",
      "Praktikum": "Sangat Besar",
      "Kerja Lapangan": "Besar",
      "Diskusi": "Cukup Besar"
    },
    "mengetahui_cced": "Ya",
    "layanan_cced": "Ya",
    "pendapatan_pertama": "item1",
    "question6": "item1",
    "question6_1": "6 bulan",
    "memperoleh_pekerjaan_pertama": "item1",
    "question7_1": "6 bulan",
    "situasi_saat_ini": "item1",
    "bagaimana_anda_mencari_pekerjaan": ["Memeroleh informasi dari pusat\/kantor pengembangan karir fakultas\/universitas"],
    "berapa_yang_sudah_dilamar_sebelum_bekerja_pertama": "0",
    "berapa_perusahaan_merespon_lamaran": "0",
    "berapa_perusahaan_mengundang_wawancara?": "0",
    "jenis_perusahaan_tempat_bekerja": "Institusi\/organisasi multilateral",
    "nama_perusahaan": "universitas lampung",
    "provinsi_tempat_kerja": "lampung",
    "kota_tempat_kerja": "bandar lampung",
    "nama_atasan": "pak budi",
    "nomer_wa_atasan": "089514213213",
    "question25": "pakbudi@gmail.com",
    "bidang_pekerjaan": "Informasi dan Komunikasi",
    "pendapatan_setiap_bulan": "3000000",
    "hubungan_bidang_studi_dengan_pekerjaan": "Sangat Erat",
    "question31": "Tingkat yang Sama",
    "mengapa_mengambil_pekerjaan_tidak_sesuai": "Di pekerjaan ini saya memperoleh prospek karir yang baik",
    "tingkat_kompetensi_yang_dikuasai?": {
      "Pengetahuan di dalam bidang atau disiplin ilmu Anda": "1",
      "Pengetahuan di luar bidang atau disiplin ilmu Anda": "1",
      "Pengetahuan umum": "3",
      "Bahasa Asing": "1",
      "Keterampilan internet": "1",
      "Keterampilan komputer": "1",
      "Berpikir kritis": "3",
      "Keterampilan riset": "1",
      "Kemampuan belajar": "1",
      "Kemampuan berkomunikasi": "3",
      "Bekerja di bawah tekanan": "1",
      "Manajemen waktu": "2",
      "Bekerja secara mandiri": "1",
      "Bekerja dalam tim \/ bekerjasama dengan orang lain": "1",
      "Kemampuan dalam memecahkan masalah": "3",
      "Negosiasi": "1",
      "Kemampuan analisis": "1",
      "Toleransi": "3",
      "Kemampuan adaptasi": "1",
      "Loyalitas": "1",
      "Integritas": "1",
      "Bekerja dengan orang yang berbeda budaya maupun latar belakang": "3",
      "Kepemimpinan": "1",
      "Kemampuan dalam memegang tanggung jawab": "1",
      "Inisiatif": "1",
      "Manajemen proyek atau program": "1",
      "Kemampuan untuk memresentasikan ide atau produk atau laporan": "1",
      "Kemampuan dalam menulis laporan, memo dan dokumen": "1",
      "Kemampuan untuk terus belajar sepanjang hayat": "1"
    },
    "question61": {
      "Pengetahuan di dalam bidang atau disiplin ilmu Anda": "1",
      "Pengetahuan di luar bidang atau disiplin ilmu Anda": "1",
      "Pengetahuan umum": "3",
      "Bahasa Asing": "1",
      "Keterampilan internet": "1",
      "Keterampilan komputer": "1",
      "Berpikir kritis": "1",
      "Keterampilan riset": "1",
      "Kemampuan belajar": "1",
      "Kemampuan berkomunikasi": "1",
      "Bekerja di bawah tekanan": "1",
      "Manajemen waktu": "1",
      "Bekerja secara mandiri": "1",
      "Bekerja dalam tim \/ bekerjasama dengan orang lain": "1",
      "Kemampuan dalam memecahkan masalah": "3",
      "Negosiasi": "1",
      "Kemampuan analisis": "1",
      "Toleransi": "1",
      "Kemampuan adaptasi": "1",
      "Loyalitas": "1",
      "Integritas": "1",
      "Bekerja dengan orang yang berbeda budaya maupun latar belakang": "1",
      "Kepemimpinan": "1",
      "Kemampuan dalam memegang tanggung jawab": "3",
      "Inisiatif": "1",
      "Manajemen proyek atau program": "1",
      "Kemampuan untuk memresentasikan ide atau produk atau laporan": "1",
      "Kemampuan dalam menulis laporan, memo dan dokumen": "2",
      "Kemampuan untuk terus belajar sepanjang hayat": "3"
    }
  }
  const thridhResult = {
    "jalur_masuk": "SBMPTN",
    "sumber_dana_kuliah": "BIDIKMISI",
    "metode_pembelajaran": {
      "Perkuliahan": "Sangat Besar",
      "Demonstrasi": "Besar",
      "Partisipasi dalam proyek riset": "Sangat Besar",
      "Praktikum": "Sangat Besar",
      "Kerja Lapangan": "Besar",
      "Diskusi": "Cukup Besar"
    },
    "mengetahui_cced": "Ya",
    "layanan_cced": "Ya",
    "pendapatan_pertama": "item1",
    "question6": "item1",
    "question6_1": "6 bulan",
    "memperoleh_pekerjaan_pertama": "item1",
    "question7_1": "6 bulan",
    "situasi_saat_ini": "item1",
    "bagaimana_anda_mencari_pekerjaan": ["Memeroleh informasi dari pusat\/kantor pengembangan karir fakultas\/universitas"],
    "berapa_yang_sudah_dilamar_sebelum_bekerja_pertama": "0",
    "berapa_perusahaan_merespon_lamaran": "0",
    "berapa_perusahaan_mengundang_wawancara?": "0",
    "jenis_perusahaan_tempat_bekerja": "Institusi\/organisasi multilateral",
    "nama_perusahaan": "universitas lampung",
    "provinsi_tempat_kerja": "lampung",
    "kota_tempat_kerja": "bandar lampung",
    "nama_atasan": "pak budi",
    "nomer_wa_atasan": "089514213213",
    "question25": "pakbudi@gmail.com",
    "bidang_pekerjaan": "Informasi dan Komunikasi",
    "pendapatan_setiap_bulan": "3000000",
    "hubungan_bidang_studi_dengan_pekerjaan": "Sangat Erat",
    "question31": "Tingkat yang Sama",
    "mengapa_mengambil_pekerjaan_tidak_sesuai": "Di pekerjaan ini saya memperoleh prospek karir yang baik",
    "tingkat_kompetensi_yang_dikuasai?": {
      "Pengetahuan di dalam bidang atau disiplin ilmu Anda": "1",
      "Pengetahuan di luar bidang atau disiplin ilmu Anda": "1",
      "Pengetahuan umum": "3",
      "Bahasa Asing": "1",
      "Keterampilan internet": "1",
      "Keterampilan komputer": "1",
      "Berpikir kritis": "3",
      "Keterampilan riset": "1",
      "Kemampuan belajar": "1",
      "Kemampuan berkomunikasi": "3",
      "Bekerja di bawah tekanan": "1",
      "Manajemen waktu": "2",
      "Bekerja secara mandiri": "1",
      "Bekerja dalam tim \/ bekerjasama dengan orang lain": "1",
      "Kemampuan dalam memecahkan masalah": "3",
      "Negosiasi": "1",
      "Kemampuan analisis": "1",
      "Toleransi": "3",
      "Kemampuan adaptasi": "1",
      "Loyalitas": "1",
      "Integritas": "1",
      "Bekerja dengan orang yang berbeda budaya maupun latar belakang": "3",
      "Kepemimpinan": "1",
      "Kemampuan dalam memegang tanggung jawab": "1",
      "Inisiatif": "1",
      "Manajemen proyek atau program": "1",
      "Kemampuan untuk memresentasikan ide atau produk atau laporan": "1",
      "Kemampuan dalam menulis laporan, memo dan dokumen": "1",
      "Kemampuan untuk terus belajar sepanjang hayat": "1"
    },
    "question61": {
      "Pengetahuan di dalam bidang atau disiplin ilmu Anda": "1",
      "Pengetahuan di luar bidang atau disiplin ilmu Anda": "1",
      "Pengetahuan umum": "3",
      "Bahasa Asing": "1",
      "Keterampilan internet": "1",
      "Keterampilan komputer": "1",
      "Berpikir kritis": "1",
      "Keterampilan riset": "1",
      "Kemampuan belajar": "1",
      "Kemampuan berkomunikasi": "1",
      "Bekerja di bawah tekanan": "1",
      "Manajemen waktu": "1",
      "Bekerja secara mandiri": "1",
      "Bekerja dalam tim \/ bekerjasama dengan orang lain": "1",
      "Kemampuan dalam memecahkan masalah": "3",
      "Negosiasi": "1",
      "Kemampuan analisis": "1",
      "Toleransi": "1",
      "Kemampuan adaptasi": "1",
      "Loyalitas": "1",
      "Integritas": "1",
      "Bekerja dengan orang yang berbeda budaya maupun latar belakang": "1",
      "Kepemimpinan": "1",
      "Kemampuan dalam memegang tanggung jawab": "3",
      "Inisiatif": "1",
      "Manajemen proyek atau program": "1",
      "Kemampuan untuk memresentasikan ide atau produk atau laporan": "1",
      "Kemampuan dalam menulis laporan, memo dan dokumen": "2",
      "Kemampuan untuk terus belajar sepanjang hayat": "3"
    }
  }
  const FourResult = {
    "jalur_masuk": "SNMPTM",
    "sumber_dana_kuliah": "BIDIKMISI",
    "metode_pembelajaran": {
      "Perkuliahan": "Sangat Besar",
      "Demonstrasi": "Besar",
      "Partisipasi dalam proyek riset": "Sangat Besar",
      "Praktikum": "Sangat Besar",
      "Kerja Lapangan": "Besar",
      "Diskusi": "Cukup Besar"
    },
    "mengetahui_cced": "Ya",
    "layanan_cced": "Ya",
    "pendapatan_pertama": "item1",
    "question6": "item1",
    "question6_1": "6 bulan",
    "memperoleh_pekerjaan_pertama": "item1",
    "question7_1": "6 bulan",
    "situasi_saat_ini": "item1",
    "bagaimana_anda_mencari_pekerjaan": ["Memeroleh informasi dari pusat\/kantor pengembangan karir fakultas\/universitas"],
    "berapa_yang_sudah_dilamar_sebelum_bekerja_pertama": "0",
    "berapa_perusahaan_merespon_lamaran": "0",
    "berapa_perusahaan_mengundang_wawancara?": "0",
    "jenis_perusahaan_tempat_bekerja": "Institusi\/organisasi multilateral",
    "nama_perusahaan": "universitas lampung",
    "provinsi_tempat_kerja": "lampung",
    "kota_tempat_kerja": "bandar lampung",
    "nama_atasan": "pak budi",
    "nomer_wa_atasan": "089514213213",
    "question25": "pakbudi@gmail.com",
    "bidang_pekerjaan": "Informasi dan Komunikasi",
    "pendapatan_setiap_bulan": "3000000",
    "hubungan_bidang_studi_dengan_pekerjaan": "Sangat Erat",
    "question31": "Tingkat yang Sama",
    "mengapa_mengambil_pekerjaan_tidak_sesuai": "Di pekerjaan ini saya memperoleh prospek karir yang baik",
    "tingkat_kompetensi_yang_dikuasai?": {
      "Pengetahuan di dalam bidang atau disiplin ilmu Anda": "1",
      "Pengetahuan di luar bidang atau disiplin ilmu Anda": "1",
      "Pengetahuan umum": "3",
      "Bahasa Asing": "1",
      "Keterampilan internet": "1",
      "Keterampilan komputer": "1",
      "Berpikir kritis": "3",
      "Keterampilan riset": "1",
      "Kemampuan belajar": "1",
      "Kemampuan berkomunikasi": "3",
      "Bekerja di bawah tekanan": "1",
      "Manajemen waktu": "2",
      "Bekerja secara mandiri": "1",
      "Bekerja dalam tim \/ bekerjasama dengan orang lain": "1",
      "Kemampuan dalam memecahkan masalah": "3",
      "Negosiasi": "1",
      "Kemampuan analisis": "1",
      "Toleransi": "3",
      "Kemampuan adaptasi": "1",
      "Loyalitas": "1",
      "Integritas": "1",
      "Bekerja dengan orang yang berbeda budaya maupun latar belakang": "3",
      "Kepemimpinan": "1",
      "Kemampuan dalam memegang tanggung jawab": "1",
      "Inisiatif": "1",
      "Manajemen proyek atau program": "1",
      "Kemampuan untuk memresentasikan ide atau produk atau laporan": "1",
      "Kemampuan dalam menulis laporan, memo dan dokumen": "1",
      "Kemampuan untuk terus belajar sepanjang hayat": "1"
    },
    "question61": {
      "Pengetahuan di dalam bidang atau disiplin ilmu Anda": "1",
      "Pengetahuan di luar bidang atau disiplin ilmu Anda": "1",
      "Pengetahuan umum": "3",
      "Bahasa Asing": "1",
      "Keterampilan internet": "1",
      "Keterampilan komputer": "1",
      "Berpikir kritis": "1",
      "Keterampilan riset": "1",
      "Kemampuan belajar": "1",
      "Kemampuan berkomunikasi": "1",
      "Bekerja di bawah tekanan": "1",
      "Manajemen waktu": "1",
      "Bekerja secara mandiri": "1",
      "Bekerja dalam tim \/ bekerjasama dengan orang lain": "1",
      "Kemampuan dalam memecahkan masalah": "3",
      "Negosiasi": "1",
      "Kemampuan analisis": "1",
      "Toleransi": "1",
      "Kemampuan adaptasi": "1",
      "Loyalitas": "1",
      "Integritas": "1",
      "Bekerja dengan orang yang berbeda budaya maupun latar belakang": "1",
      "Kepemimpinan": "1",
      "Kemampuan dalam memegang tanggung jawab": "3",
      "Inisiatif": "1",
      "Manajemen proyek atau program": "1",
      "Kemampuan untuk memresentasikan ide atau produk atau laporan": "1",
      "Kemampuan dalam menulis laporan, memo dan dokumen": "2",
      "Kemampuan untuk terus belajar sepanjang hayat": "3"
    }
  }
  const FiveResult = {
    "jalur_masuk": "SNMPTM",
    "sumber_dana_kuliah": "BIDIKMISI",
    "metode_pembelajaran": {
      "Perkuliahan": "Sangat Besar",
      "Demonstrasi": "Besar",
      "Partisipasi dalam proyek riset": "Sangat Besar",
      "Praktikum": "Sangat Besar",
      "Kerja Lapangan": "Besar",
      "Diskusi": "Cukup Besar"
    },
    "mengetahui_cced": "Ya",
    "layanan_cced": "Ya",
    "pendapatan_pertama": "item1",
    "question6": "item1",
    "question6_1": "6 bulan",
    "memperoleh_pekerjaan_pertama": "item1",
    "question7_1": "6 bulan",
    "situasi_saat_ini": "item1",
    "bagaimana_anda_mencari_pekerjaan": ["Memeroleh informasi dari pusat\/kantor pengembangan karir fakultas\/universitas"],
    "berapa_yang_sudah_dilamar_sebelum_bekerja_pertama": "0",
    "berapa_perusahaan_merespon_lamaran": "0",
    "berapa_perusahaan_mengundang_wawancara?": "0",
    "jenis_perusahaan_tempat_bekerja": "Institusi\/organisasi multilateral",
    "nama_perusahaan": "universitas lampung",
    "provinsi_tempat_kerja": "lampung",
    "kota_tempat_kerja": "bandar lampung",
    "nama_atasan": "pak budi",
    "nomer_wa_atasan": "089514213213",
    "question25": "pakbudi@gmail.com",
    "bidang_pekerjaan": "Informasi dan Komunikasi",
    "pendapatan_setiap_bulan": "3000000",
    "hubungan_bidang_studi_dengan_pekerjaan": "Sangat Erat",
    "question31": "Tingkat yang Sama",
    "mengapa_mengambil_pekerjaan_tidak_sesuai": "Di pekerjaan ini saya memperoleh prospek karir yang baik",
    "tingkat_kompetensi_yang_dikuasai?": {
      "Pengetahuan di dalam bidang atau disiplin ilmu Anda": "1",
      "Pengetahuan di luar bidang atau disiplin ilmu Anda": "1",
      "Pengetahuan umum": "3",
      "Bahasa Asing": "1",
      "Keterampilan internet": "1",
      "Keterampilan komputer": "1",
      "Berpikir kritis": "3",
      "Keterampilan riset": "1",
      "Kemampuan belajar": "1",
      "Kemampuan berkomunikasi": "3",
      "Bekerja di bawah tekanan": "1",
      "Manajemen waktu": "2",
      "Bekerja secara mandiri": "1",
      "Bekerja dalam tim \/ bekerjasama dengan orang lain": "1",
      "Kemampuan dalam memecahkan masalah": "3",
      "Negosiasi": "1",
      "Kemampuan analisis": "1",
      "Toleransi": "3",
      "Kemampuan adaptasi": "1",
      "Loyalitas": "1",
      "Integritas": "1",
      "Bekerja dengan orang yang berbeda budaya maupun latar belakang": "3",
      "Kepemimpinan": "1",
      "Kemampuan dalam memegang tanggung jawab": "1",
      "Inisiatif": "1",
      "Manajemen proyek atau program": "1",
      "Kemampuan untuk memresentasikan ide atau produk atau laporan": "1",
      "Kemampuan dalam menulis laporan, memo dan dokumen": "1",
      "Kemampuan untuk terus belajar sepanjang hayat": "1"
    },
    "question61": {
      "Pengetahuan di dalam bidang atau disiplin ilmu Anda": "1",
      "Pengetahuan di luar bidang atau disiplin ilmu Anda": "1",
      "Pengetahuan umum": "3",
      "Bahasa Asing": "1",
      "Keterampilan internet": "1",
      "Keterampilan komputer": "1",
      "Berpikir kritis": "1",
      "Keterampilan riset": "1",
      "Kemampuan belajar": "1",
      "Kemampuan berkomunikasi": "1",
      "Bekerja di bawah tekanan": "1",
      "Manajemen waktu": "1",
      "Bekerja secara mandiri": "1",
      "Bekerja dalam tim \/ bekerjasama dengan orang lain": "1",
      "Kemampuan dalam memecahkan masalah": "3",
      "Negosiasi": "1",
      "Kemampuan analisis": "1",
      "Toleransi": "1",
      "Kemampuan adaptasi": "1",
      "Loyalitas": "1",
      "Integritas": "1",
      "Bekerja dengan orang yang berbeda budaya maupun latar belakang": "1",
      "Kepemimpinan": "1",
      "Kemampuan dalam memegang tanggung jawab": "3",
      "Inisiatif": "1",
      "Manajemen proyek atau program": "1",
      "Kemampuan untuk memresentasikan ide atau produk atau laporan": "1",
      "Kemampuan dalam menulis laporan, memo dan dokumen": "2",
      "Kemampuan untuk terus belajar sepanjang hayat": "3"
    }
  }



export const data = [firstResult, secondResult, thridhResult, FourResult, FiveResult];
